import { useEffect, useState, useRef } from "react";
import { db } from "../../firebase";
import {
  collection,
  query,
  orderBy,
  onSnapshot
} from "firebase/firestore";

export default function AttachmentsModal({ chatId, onClose, onJump }) {
  const [messages, setMessages] = useState([]);
  const [tab, setTab] = useState("image");
  const [viewerIndex, setViewerIndex] = useState(null);

   const touchStartX = useRef(0);

const handleTouchStart = (e) => {
  touchStartX.current = e.touches[0].clientX;
};

const handleTouchEnd = (e) => {
  const delta = e.changedTouches[0].clientX - touchStartX.current;

  if (delta > 50) {
    // 👉 свайп вправо
    setViewerIndex((i) =>
      i > 0 ? i - 1 : i
    );
  }

  if (delta < -50) {
    // 👉 свайп влево
    setViewerIndex((i) =>
      i < mediaList.length - 1 ? i + 1 : i
    );
  }
};

  // ===============================
  // 🔥 загрузка сообщений
  // ===============================
  useEffect(() => {
    if (!chatId) return;

    const q = query(
      collection(db, "chats", chatId, "messages"),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(q, (snap) => {
      setMessages(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data()
        }))
      );
    });

    return () => unsub();
  }, [chatId]);
  // ===============================
  // 🔥 фильтр
  // ===============================
  const filtered = messages.filter((m) => {
    if (tab === "image") return m.image;
    if (tab === "video") return m.video;
    if (tab === "voice") return m.voice;
    if (tab === "doc") return m.file;
    if (tab === "link") return m.text?.includes("http");
    return false;
  });

  const mediaList = filtered.filter(m => m.image || m.video);

  // ===============================
  // 📅 группировка по датам
  // ===============================
  const groupByDate = (list) => {
    const groups = {};

    list.forEach((m) => {
      const date = new Date(m.createdAt);
      const key = date.toLocaleDateString();

      if (!groups[key]) groups[key] = [];
      groups[key].push(m);
    });

    return groups;
  };

  const grouped = groupByDate(filtered);


useEffect(() => {
  if (viewerIndex === null) return;

  const handleKey = (e) => {
    // 💥 ЖЁСТКО блокируем ВСЁ
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) {
      e.stopImmediatePropagation();
    }

    if (e.key === "ArrowLeft") {
      setViewerIndex((i) => (i > 0 ? i - 1 : i));
    }

    if (e.key === "ArrowRight") {
      setViewerIndex((i) =>
        i < mediaList.length - 1 ? i + 1 : i
      );
    }

    if (e.key === "Escape") {
      setViewerIndex(null);
    }
  };

  // 🔥 ВАЖНО: capture = true
  window.addEventListener("keydown", handleKey, true);

  return () => {
    window.removeEventListener("keydown", handleKey, true);
  };
}, [viewerIndex, mediaList.length]);

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>

        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.title}>Вложения</div>
          <div style={styles.close} onClick={onClose}>✕</div>
        </div>

        {/* TABS */}
        <div style={styles.tabs}>
          {[
            ["image", "Фото"],
            ["video", "Видео"],
            ["voice", "Голос"],
            ["doc", "Док"],
            ["link", "Ссылки"],
          ].map(([key, label]) => (
            <div
              key={key}
              onClick={() => setTab(key)}
              style={{
                ...styles.tab,
                ...(tab === key ? styles.tabActive : {})
              }}
            >
              {label}
            </div>
          ))}
        </div>

        {/* CONTENT */}
        <div style={styles.content}>
          {filtered.length === 0 && (
            <div style={styles.empty}>Ничего нет</div>
          )}

          {Object.entries(grouped).map(([date, items]) => (
            <div key={date}>
              
              <div style={styles.date}>{date}</div>

              <div style={styles.grid}>
                {items.map((m) => (
                  <div
                    key={m.id}
                    style={styles.card}
                    onClick={() => {
                      if (m.image || m.video) {
                        const index = mediaList.findIndex(x => x.id === m.id);
setViewerIndex(index);
                      } else {
                        onJump(chatId, m.id);
                        onClose();
                      }
                    }}
                    onMouseEnter={(e) => {
                      const overlay = e.currentTarget.querySelector(".overlay");
                      if (overlay) overlay.style.opacity = 1;
                    }}
                    onMouseLeave={(e) => {
                      const overlay = e.currentTarget.querySelector(".overlay");
                      if (overlay) overlay.style.opacity = 0;
                    }}
                  >
                    {/* IMAGE */}
                    {m.image && (
                      <img
                        src={m.image}
                        loading="lazy"
                        style={styles.image}
                      />
                    )}

                    {/* VIDEO */}
                    {m.video && (
                      <video
                        src={m.video}
                        preload="metadata"
                        style={styles.image}
                      />
                    )}

                    {/* LINK */}
                    {!m.image && !m.video && m.text && (
                      <div style={styles.link}>
                        {m.text.slice(0, 60)}
                      </div>
                    )}

                    {/* 🔥 JUMP КНОПКА */}
                    <div
                      style={styles.jumpBtn}
                      onClick={(e) => {
                        e.stopPropagation();
                        onJump(m.id);
                        onClose();
                      }}
                    >
                      ↗
                    </div>

                    {/* OVERLAY */}
                    <div className="overlay" style={styles.overlayHover}>
                      ⤢
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

      </div>

      {/* 🔥 FULLSCREEN VIEWER */}
     {viewerIndex !== null && mediaList[viewerIndex] && (
  <div
    style={styles.viewer}
    onClick={(e) => {
      e.stopPropagation();
      setViewerIndex(null);
    }}
    onTouchStart={handleTouchStart}
    onTouchEnd={handleTouchEnd}
  >
    <div
  style={{
    display: "flex",
    height: "100%",
    transform: `translateX(-${viewerIndex * 100}%)`,
    transition: "transform 0.35s ease"
  }}
>
  {mediaList.map((m, i) => (
    <div
      key={m.id}
      style={{
        minWidth: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      {m.image && (
        <img
          src={m.image}
          style={styles.viewerMedia}
          onClick={(e) => e.stopPropagation()}
        />
      )}

      {m.video && (
        <video
          src={m.video}
          controls
          autoPlay={i === viewerIndex}
          style={styles.viewerMedia}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>
  ))}
</div>

    {/* ← стрелка */}
    {viewerIndex > 0 && (
      <div
        style={styles.arrowLeft}
        onClick={(e) => {
          e.stopPropagation();
          setViewerIndex(viewerIndex - 1);
        }}
      >
        ‹
      </div>
    )}

    {/* → стрелка */}
    {viewerIndex < mediaList.length - 1 && (
      <div
        style={styles.arrowRight}
        onClick={(e) => {
          e.stopPropagation();
          setViewerIndex(viewerIndex + 1);
        }}
      >
        ›
      </div>
    )}

            <div style={styles.counter}>
            {viewerIndex + 1} / {mediaList.length}
            </div>

  </div>

)}
    </div>


  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.65)",
    backdropFilter: "blur(14px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
  },

  modal: {
    width: 480,
    maxHeight: "85vh",
    borderRadius: 20,
    overflow: "hidden",
    background: "rgba(20,20,20,0.85)",
    border: "1px solid rgba(255,255,255,0.08)",
    backdropFilter: "blur(20px)",
    display: "flex",
    flexDirection: "column"
  },

  header: {
    padding: "14px 16px",
    display: "flex",
    justifyContent: "space-between"
  },

  title: {
    fontWeight: 600,
    fontSize: 14
  },

  close: {
    cursor: "pointer",
    opacity: 0.7
  },

  tabs: {
    display: "flex",
    gap: 8,
    padding: "0 10px 10px",
    overflowX: "auto"
  },

  tab: {
    padding: "6px 10px",
    borderRadius: 10,
    background: "rgba(255,255,255,0.05)",
    fontSize: 12,
    cursor: "pointer"
  },

  tabActive: {
    background: "rgba(255,255,255,0.15)"
  },

  content: {
    overflowY: "auto"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 8,
    padding: 10
  },

  card: {
    position: "relative",
    borderRadius: 12,
    overflow: "hidden",
    background: "rgba(255,255,255,0.04)",
    aspectRatio: "1/1",
    cursor: "pointer"
  },

  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },

  link: {
    padding: 8,
    fontSize: 11,
    opacity: 0.7
  },

  overlayHover: {
    position: "absolute",
    inset: 0,
    background: "rgba(0,0,0,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    opacity: 0,
    transition: "0.2s"
  },

  jumpBtn: {
    position: "absolute",
    top: 6,
    right: 6,
    width: 22,
    height: 22,
    borderRadius: 6,
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    cursor: "pointer",
    zIndex: 2
  },

  empty: {
    padding: 20,
    textAlign: "center",
    opacity: 0.5
  },

  viewer: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.95)",
    backdropFilter: "blur(10px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  },

  viewerMedia: {
    maxWidth: "90%",
    maxHeight: "90%",
    borderRadius: 12
  },

  date: {
    fontSize: 12,
    opacity: 0.5,
    padding: "6px 12px"
  },
  arrowLeft: {
  position: "absolute",
  left: 20,
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: 40,
  cursor: "pointer",
  opacity: 0.6,
},

arrowRight: {
  position: "absolute",
  right: 20,
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: 40,
  cursor: "pointer",
  opacity: 0.6,
},

counter: {
  position: "absolute",
  bottom: 20,
  left: "50%",
  transform: "translateX(-50%)",
  padding: "6px 12px",
  borderRadius: 12,
  background: "rgba(0,0,0,0.6)",
  fontSize: 12,
  backdropFilter: "blur(10px)"
},
};